var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 69,
    viewBox: "0 0 71 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5303 1.97026C53.9988 4.40622 73.3029 14.6937 70.0784 39.7181L63.9434 39.719L63.5361 39.7092C63.5886 37.368 67.0496 17.0964 43.1859 8.25707L46.5302 1.97035L46.5303 1.97026ZM35.6668 68.6179C50.865 69.2725 61.4397 59.5845 66.3357 50.655L31.2266 50.6478L28.367 56.1124H54.1938C49.2298 60.3815 41.4818 63.0259 35.6634 63.0259C32.2782 63.0259 28.9249 62.3643 25.7791 61.1569C25.7785 61.1567 25.7771 61.156 25.7771 61.1561L23.1657 66.2455L23.1667 66.2459C26.8733 67.584 31.0398 68.4184 35.6668 68.6178V68.6179ZM16.3348 55.2996C14.019 53.1742 12.0712 50.7006 10.5996 47.9363C10.2009 47.1647 9.83912 46.3525 9.51194 45.5195C4.22916 32.0687 10.1765 10.5333 32.2974 7.71893L36.1613 0.328369C-1.6662 1.00055 -8.95017 43.1458 13.4921 60.9044L16.3717 55.3887L16.3711 55.3886C16.3673 55.3801 16.335 55.2999 16.3347 55.2996L16.3348 55.2996Z",
    fill: "#7C2C78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2965 30.2535L23.1729 30.1732L23.9222 28.7468L24.0853 28.7522L23.2965 30.2535Z",
    fill: "url(#paint0_linear_2267_2319)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9386 0.446045C40.8627 0.7002 42.6377 1.03486 44.589 1.44992L41.3393 7.57692L22.5941 43.419H25.4878L38.6799 18.1945L54.373 48.2007C45.9785 48.2007 37.5838 48.2007 29.1893 48.2007L23.0441 59.9445C21.5058 59.1092 20.3952 58.5859 18.3683 57.0225L22.9979 48.1919L20.0933 48.2007H18.4721H13.8848C22.1712 32.3565 30.7574 16.0899 38.9387 0.446045H38.9386ZM38.6799 28.5922L30.9256 43.4191H46.4342L38.6799 28.5922V28.5922Z",
    fill: "url(#paint1_radial_2267_2319)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9255 43.4201H46.4341L38.6798 28.5933L38.2327 29.4484L45.1535 42.6815H31.3119L30.9255 43.4201Z",
    fill: "url(#paint2_linear_2267_2319)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5857 43.4193H24.8649L25.2543 42.6807H22.972L22.5857 43.4193Z",
    fill: "url(#paint3_linear_2267_2319)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2608 8.11574C43.2744 8.08986 43.2659 8.18587 43.2941 8.19565C49.7388 10.4458 65.9645 18.453 63.5348 39.7181L61.6702 37.4513C61.6561 37.4313 61.7264 36.2999 61.7272 36.2736C61.9814 28.9651 59.7627 14.1563 42.7156 9.27322L42.6592 9.25702L43.2608 8.11574V8.11574Z",
    fill: "url(#paint4_linear_2267_2319)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9109 6.48804L32.4597 7.40864C32.6101 7.10164 32.7605 6.79494 32.9109 6.48804Z",
    fill: "#FEFEFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9255 43.4201H46.4341L38.6798 28.5933L38.2327 29.4484L45.1535 42.6815H31.3119L30.9255 43.4201Z",
    fill: "url(#paint5_linear_2267_2319)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5857 43.4193H24.8649L25.2543 42.6807H22.972L22.5857 43.4193Z",
    fill: "url(#paint6_linear_2267_2319)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3658 59.9105C25.3789 59.9134 25.6993 60.0434 25.7119 60.0479C30.0254 61.5822 40.0726 63.641 50.7872 56.1128H54.1936C52.4462 57.8043 40.6409 66.9403 25.7754 61.1632C25.7714 61.1616 25.7639 61.1624 25.7627 61.1581L25.3611 59.9094L25.3658 59.9105V59.9105Z",
    fill: "url(#paint7_linear_2267_2319)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5348 39.7181L63.9432 39.7189C65.8335 24.9311 57.4795 11.9409 43.365 8.00745L43.3243 7.99609L43.0545 8.50737C43.0539 8.50856 43.088 8.51616 43.1052 8.5209C56.1361 12.1422 65.1902 24.0125 63.5347 39.7181H63.5348Z",
    fill: "#FEFEFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9109 6.48804L32.4597 7.40864C32.6101 7.10164 32.7605 6.79494 32.9109 6.48804Z",
    fill: "#FEFEFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3722 55.3901C11.3692 50.6414 7.49149 43.7329 7.38705 36.3557C7.17977 21.689 16.9774 8.78914 32.4595 7.40832L32.7842 6.78711C17.3983 7.69191 6.64002 20.7081 6.65309 35.5113C6.66027 43.7028 10.5975 50.8619 16.0613 55.9878L16.3722 55.3901Z",
    fill: "#FEFEFE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3934 57.0227L23.2799 59.4942C22.3131 61.3681 21.3468 63.2422 20.3802 65.1162C18.5988 64.2774 17.1965 63.5404 15.5952 62.4471L18.3935 57.0227H18.3934Z",
    fill: "url(#paint8_linear_2267_2319)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3993 8.99292L30.9497 9.91047C31.0996 9.60465 31.2494 9.29874 31.3993 8.99292Z",
    fill: "#FEFEFE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5033 61.6828C25.5027 61.684 25.5073 61.6843 25.5089 61.6848C28.6835 62.8649 32.1388 63.5201 35.7351 63.5201C42.9221 63.5201 49.4503 60.8653 54.4797 56.5356C54.5048 56.5141 54.7598 56.2556 54.9002 56.1155L54.1935 56.1128C52.2202 57.7939 50.0173 59.213 47.6391 60.3214C46.9105 60.6608 46.1662 60.9773 45.4077 61.256C42.3954 62.3624 39.1517 62.9839 35.735 62.9839C32.241 62.9839 28.878 62.3302 25.7842 61.1584C25.7829 61.1578 25.7804 61.1556 25.7798 61.1566L25.5032 61.6828H25.5033Z",
    fill: "#FEFEFE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8228 64.8664L23.1669 66.2457L25.7846 61.1577L25.366 59.9099L22.8228 64.8664Z",
    fill: "url(#paint9_linear_2267_2319)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2267_2319",
    x1: 24.0338,
    y1: 29.8479,
    x2: 23.2311,
    y2: 29.1447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C2C78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2267_2319",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.8991 43.8833) rotate(101.211) scale(29.2185 29.4845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009E43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2267_2319",
    x1: 30.9256,
    y1: 36.0067,
    x2: 36.4814,
    y2: 63.0398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C2C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309804,
    stopColor: "#4E244C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1B20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2267_2319",
    x1: 22.5857,
    y1: 42.6807,
    x2: 22.8926,
    y2: 61.3124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C2C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1B20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2267_2319",
    x1: 49.5801,
    y1: 50.0326,
    x2: 23.1059,
    y2: 17.5125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541176,
    stopColor: "#532B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C2C78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2267_2319",
    x1: 30.9256,
    y1: 36.0067,
    x2: 36.4814,
    y2: 63.0398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C2C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309804,
    stopColor: "#4E244C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1B20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2267_2319",
    x1: 22.5857,
    y1: 42.6807,
    x2: 22.8926,
    y2: 61.3124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C2C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1B20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2267_2319",
    x1: 34.2511,
    y1: 68.9974,
    x2: 50.3566,
    y2: 34.7238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529412,
    stopColor: "#532B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C2C78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2267_2319",
    x1: 20.4953,
    y1: 58.0858,
    x2: 17.5199,
    y2: 63.6511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009E43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2267_2319",
    x1: 28.5187,
    y1: 64.4971,
    x2: 11.4617,
    y2: 77.1644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988235,
    stopColor: "#532B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C2C78"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticon);
export default __webpack_public_path__ + "static/media/staticon.80166894891ebc7b32dc250d640415f1.svg";
export { ForwardRef as ReactComponent };